import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { greys } from "@clockwise/web-commons/src/styles/color.styles";

export const container: CSSProperties = {
  display: "flex",
  alignItems: "center",
  marginLeft: -2,
};

export const select = {
  underlineStyle: {
    borderColor: `#96ACC0`,
  },
  iconStyle: {
    fill: `#96ACC0`,
  },
  style: {
    width: `100%`,
    fontSize: 14,
    fontWeight: 300,
    flexGrow: 2,
  } as CSSProperties,
};

export const label = {
  color: greys.slate,
};

export const styles = {
  container,
  select,
  label,
};
